import React from "react";
import {
  Zap,
  Target,
  Layers,
  Shield,
  Monitor,
  Award,
} from "lucide-react";
import { advantages } from "../data/mock";

const iconMap = {
  Zap,
  Target,
  Layers,
  Shield,
  Monitor,
  Award,
};

export const WhyFormlabsSection = () => {
  return (
    <section
      id="why-formlabs"
      className="py-24 lg:py-32 bg-[#0A0A0A] relative"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[400px] bg-[#F76B1C]/[0.015] rounded-full blur-[160px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section header */}
        <div className="max-w-2xl mb-16 lg:mb-20">
          <span className="text-[#F76B1C] text-sm font-semibold uppercase tracking-[0.15em]">
            Why Formlabs
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
            The Gold Standard in Professional SLA Printing
          </h2>
          <p className="mt-6 text-lg text-white/45 leading-relaxed">
            We chose to partner with Formlabs because they deliver what
            matters most: consistent quality, an unmatched material library,
            and a workflow that simply works.
          </p>
        </div>

        {/* Advantages grid with photos */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {advantages.map((adv, i) => {
            const IconComponent = iconMap[adv.icon];
            return (
              <div
                key={i}
                className="group relative rounded-2xl bg-white/[0.02] border border-white/[0.05] hover:border-[#F76B1C]/20 hover:bg-white/[0.035] transition-all duration-300 hover:-translate-y-1 overflow-hidden"
              >
                {/* Card image */}
                <div className="relative h-44 overflow-hidden">
                  <img loading="lazy"
                    src={adv.image}
                    alt={adv.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
                  <div className="absolute bottom-4 left-5">
                    <div className="w-10 h-10 rounded-lg bg-[#F76B1C]/[0.15] backdrop-blur-md border border-[#F76B1C]/20 flex items-center justify-center">
                      {IconComponent && (
                        <IconComponent size={18} className="text-[#F76B1C]" />
                      )}
                    </div>
                  </div>
                </div>

                {/* Card content */}
                <div className="p-6 pt-4">
                  <h3 className="text-lg font-semibold text-white mb-2.5">
                    {adv.title}
                  </h3>
                  <p className="text-[15px] text-white/40 leading-relaxed">
                    {adv.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
